import { render } from "./Screens.vue?vue&type=template&id=36e9d13e&scoped=true"
import script from "./Screens.vue?vue&type=script&lang=js"
export * from "./Screens.vue?vue&type=script&lang=js"

import "./Screens.vue?vue&type=style&index=0&id=36e9d13e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e9d13e"]])

export default __exports__